module.exports = __webpack_public_path__ + "img/80.38809b64.png";